import React, { useState } from 'react'
import {
  FormInput,
  FormInputCheckbox,
  FormInputRichText,
  FormInputText
} from 'camino-react'

const Form = ({
  canCreatePublicTemplates,
  correspondenceTemplate: {
    name: defaultName,
    content: defaultContent,
    private: defaultPrivateTemplate
  }
}) => {
  const [name, setName] = useState(defaultName)
  const [content, setContent] = useState(defaultContent)
  const [privateTemplate, setPrivate] = useState(defaultPrivateTemplate)

  return (
    <>
      <FormInput label="Name">
        <FormInputText
          name="correspondence_template[name]"
          value={name}
          onValue={value => setName(value)}
        />
      </FormInput>

      <FormInput label="Content">
        <FormInputRichText
          value={content}
          onValue={value => setContent(value)}
        />
        <input type="hidden" name="correspondence_template[content]" value={content} />
      </FormInput>

      <label className="flex">
        <FormInputCheckbox
          disabled={!canCreatePublicTemplates}
          name="correspondence_template[private]"
          value={privateTemplate}
          onValue={value => setPrivate(value)}
        /> Private

        <input type="hidden" name="correspondence_template[private]" value={privateTemplate} />
      </label>
    </>
  )
}

export default Form
